{
  "app.sabologistics.com": "sabo",
  "www.sabologistics.com": "sabo",
  "sabologistics.com": "sabo",
  "oae.sabologistics.com": "sabo",
  "23industrial.com": "sabo",
  "www.23industrial.com": "sabo",
  "app.pmpaket.eu": "pmpaket",
  "app-usa.pmpaket.eu": "pmpaket",
  "dorechi.us": "pmpaket",
  "www.dorechi.us": "pmpaket",
  "app.eastshipper.com": "eastshipper",
  "app-usa.eastshipper.com": "eastshipper"
}
